import { Component, inject, OnInit } from '@angular/core';
import { LoginService } from 'login';
import { AppLauncherComponent, TitleBarComponent } from 'mis-component-library';
import { ILsApplication } from 'src/app/models/licenseServer/ls-application.model';
import { ApplicationsService } from 'src/app/services/applications/applications.service';
import { LoadingComponent } from '../loading/loading.component';


@Component({
  selector: 'app-hub',
  templateUrl: './hub.component.html',
  styleUrls: ['./hub.component.scss'],
  standalone: true,
  imports: [
    TitleBarComponent,
    AppLauncherComponent,
    LoadingComponent
  ]
})
export class HubComponent implements OnInit {
  protected applications?: ILsApplication[];
  private readonly applicationsService = inject(ApplicationsService);
  private readonly loginService = inject(LoginService);

  public async ngOnInit(): Promise<void> {
    const response = await this.applicationsService.getApplications();
    this.applications = response.applications;
  }

  protected async logout(): Promise<void> {
    await this.loginService.signOut();
  }
}